class Map {
    constructor(canvasID, _label = null) {
        let $map = $(`#${canvasID}`);
        if ($map.length < 1) { return; }

        const LAT = $map.data('lat');
        const LNG = $map.data('lng');
        // const PIN_SIZE_X = (window.UA.isSP)?  172/4: 172/2.2;
        // const PIN_SIZE_Y = (window.UA.isSP)? 210/4: 210/2.2;
        google.maps.event.addDomListener(window, 'load', init);
        function init() {
            let mapOptions = {
                center: new google.maps.LatLng(LAT, LNG),
                zoom: (window.UA.isSP) ? 17 : 18,
                zoomControl: true,
                disableDoubleClickZoom: false,
                mapTypeControl: false,
                scaleControl: true,
                scrollwheel: false,
                panControl: false,
                streetViewControl: false,
                draggable: (window.UA.isSP) ? false : true,
                overviewMapControl: false,
                overviewMapControlOptions: {
                    opened: false
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "poi.business",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ]

            };
            let mapElement = document.getElementById(canvasID);
            let map = new google.maps.Map(mapElement, mapOptions);
            let icon = {
                url: 'http://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2_hdpi.png',
                scaledSize: new google.maps.Size(27, 43),
                labelOrigin: new google.maps.Point(120, 40)
            };
            let marker = {};
            if (_label !== null) {
                marker = new google.maps.Marker({
                    icon: icon,
                    position: new google.maps.LatLng(LAT, LNG),
                    map: map,
                    label: {
                        color: '#D95040',
                        // fontWeight: '500',
                        text: _label,
                        className: 'marker-label'
                    }
                });
            } else {
                marker = new google.maps.Marker({
                    icon: icon,
                    position: new google.maps.LatLng(LAT, LNG),
                    map: map
                });
            }
            // if(window.UA.isSP === false) {
            //     map.panBy(50, 0);
            // }

        }
        init();
    }
}

export default Map;